import { COLOR_PALETTE } from 'constants/ui';

export const getStyles = ({ palette }) => {
  const isDarkTheme = palette.type === 'dark';

  return {
    addTypeRedesign: {
      width: '24px',
      height: '24px',
      borderRadius: '6px',
      border: `1px dashed ${palette.border.input}`,
      color: COLOR_PALETTE.BRAND[6],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: 'auto',
      flexShrink: 0,
      cursor: 'pointer',
      fontSize: '17px',
      lineHeight: 1,
      background: 'none',
      padding: 0,
      minWidth: 0,
      '&:hover': {
        backgroundColor: COLOR_PALETTE.BRAND[1],
        borderStyle: 'solid',
        borderColor: COLOR_PALETTE.BRAND[3],
      },
    },
    root: {
      borderBottom: `1px solid ${palette.divider}`,
    },
    types: {
      justifyContent: 'space-between',
      paddingTop: '4px',
      paddingBottom: '4px',
      paddingLeft: '5px',
      '&:hover': {
        backgroundColor: 'unset !important',
      },
    },
    nameContainer: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    nameRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      overflow: 'hidden',
    },
    name: {
      flex: 1,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      paddingRight: '30px',
    },
    content: {
      flexDirection: 'row',
      padding: 0,
      gap: 0,
      '&:hover': {
        backgroundColor: isDarkTheme ? '#383838' : palette.action.hover,
      },
    },
    iconContainer: {
      width: 'auto',
      marginRight: '4px',
      zIndex: '9',
      '&:hover': {
        backgroundColor: isDarkTheme ? '#383838' : palette.action.hover,
      },
    },
    typeIcon: {
      left: 0,
    },
    typeLabel: {
      paddingLeft: 0,
      overflow: 'hidden',
      backgroundColor: 'unset !important',
      '& > *': {
        paddingLeft: '8px',
        paddingRight: '10px',
      },
    },
    group: {
      marginLeft: '0',
    },
    hasSelected: {
      color: palette.secondary.main,
      backgroundColor: 'unset !important',
    },
  };
};
